// eslint-disable-next-line import/prefer-default-export
export const UPDATE_OVERLAYS = 'UPDATE_OVERLAYS';
